import { DeepFilterNoiseFilterProcessor } from "deepfilternet3-noise-filter";

export type NoiseSuppressionCapabilities = {
  webAssembly: boolean;
  audioContext: boolean;
  audioWorklet: boolean;
  sharedArrayBuffer: boolean;
  packageSupport: boolean;
};

export const detectNoiseSuppressionCapabilities = (): NoiseSuppressionCapabilities => {
  const webAssembly = typeof WebAssembly !== "undefined";
  const audioContext = typeof window.AudioContext !== "undefined" || typeof (window as Window & {
    webkitAudioContext?: typeof AudioContext;
  }).webkitAudioContext !== "undefined";
  const audioWorklet = typeof AudioWorkletNode !== "undefined";

  let packageSupport = false;
  try {
    packageSupport = DeepFilterNoiseFilterProcessor.isSupported();
  } catch {
    packageSupport = false;
  }

  return {
    webAssembly,
    audioContext,
    audioWorklet,
    sharedArrayBuffer: typeof SharedArrayBuffer !== "undefined",
    packageSupport,
  };
};

export const isNoiseSuppressionSupported = () => {
  // Gate the feature on browser/runtime primitives plus package-level support
  // so unsupported environments can cleanly fall back to raw microphone audio.
  const caps = detectNoiseSuppressionCapabilities();
  return caps.webAssembly && caps.audioContext && caps.audioWorklet && caps.packageSupport;
};
